import { Component } from '@angular/core';

@Component({
  selector: 'cmg-info-panel-content',
  imports: [],
  templateUrl: './info-panel-content.component.html',
  styleUrls: ['./info-panel-content.component.scss'],
})
export class InfoPanelContentComponent {}
